import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../app/hooks';
import { Button, ErrorToast } from '../../../components';
import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { createUserWallet } from '../../../slices/wallets-slice';
import { P3 } from '../../../styles/FontStyles';
import { FlexCenter } from '../../../styles/stylesStyled';
import { Subtitle, Title } from './WithdrawStyled';

interface AddBankAccount {
  setStep?: Dispatch<SetStateAction<number>>;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

export const AddBankAccount = ({ setStep, setIsOpen }: AddBankAccount) => {
  const { t } = useTranslation('earnings');
  const dispatch = useAppDispatch();
  const [address, setAddress] = useState('');
  const [label, setLabel] = useState('');

  return (
    <div>
      <Title>{t('withdraw_part.add_bank_account.title')}</Title>
      <Subtitle style={{ textAlign: 'center' }}>
        {t('withdraw_part.add_bank_account.subtitle')}
      </Subtitle>

      <P3 mb='8' bold>
        {t('withdraw_part.add_bank_account.walletLabel')}
      </P3>

      <InputBackOffice
        placeholder={t('withdraw_part.add_bank_account.placeholderLabel')}
        style={{ marginBottom: 16 }}
        value={label}
        onChange={(e: string) => setLabel(e)}
      />

      <P3 mb='8' bold>
        {t('withdraw_part.add_bank_account.walletAddress')}
      </P3>

      <InputBackOffice
        placeholder={t('withdraw_part.add_bank_account.placeholderWallet')}
        style={{ marginBottom: 16 }}
        value={address}
        onChange={(e: string) => setAddress(e.replace(/\s+/g, ''))}
      />
      <FlexCenter style={{ flexDirection: 'column' }}>
        <Button
          onClick={() => {
            if (!address) {
              ErrorToast(
                t('withdraw_part.add_bank_account.err_address_required')
              );
            } else {
              setIsOpen && setIsOpen(false);
              dispatch(
                createUserWallet({
                  address,
                  setAddress,
                  setStep,
                  label,
                  setLabel
                })
              );
            }
          }}
          mt='30'
          maxWidth='200px'>
          {t('withdraw_part.add_bank_account.add')}
        </Button>
      </FlexCenter>
    </div>
  );
};
